import React, { useState } from 'react';
import { ArrowUpRight, Filter } from 'lucide-react';
import { portfolioItems } from '../data/mock';

const PortfolioSection = () => {
  const [filter, setFilter] = useState('All');
  const cats = ['All', ...Array.from(new Set(portfolioItems.map((p) => p.category)))];
  const visible = filter === 'All' ? portfolioItems : portfolioItems.filter((p) => p.category === filter);

  return (
    <section className="py-28 bg-white">
      <div className="container-pn">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-3">Discover more</p>
            <h2 className="text-4xl md:text-5xl font-black text-[#050F2E] tracking-tight leading-tight">
              All our products improve the <span className="text-[#0A2A63]/70 italic font-serif">industrial printing process</span>
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-slate-500 font-bold pr-2">
              <Filter className="h-3 w-3" /> Filter:
            </span>
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-4 py-2 rounded-full text-sm font-bold border-2 btn-transition ${
                  filter === c
                    ? 'bg-[#0A2A63] text-white border-[#0A2A63]'
                    : 'bg-white text-[#0A2A63] border-slate-200 hover:border-[#0A2A63]'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl btn-transition aspect-[4/5]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050F2E] via-[#050F2E]/30 to-transparent" />

              <div className="absolute top-5 left-5 inline-flex items-center bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest text-[#0A2A63]">
                {item.category}
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                <p className="text-sm text-slate-300 mb-1">{item.subtitle}</p>
                <h3 className="text-2xl font-black tracking-tight">{item.title}</h3>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold opacity-0 group-hover:opacity-100 -translate-y-2 group-hover:translate-y-0 transition-all text-[#FF4E50]">
                  View project
                  <ArrowUpRight className="h-4 w-4" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
